// extracted by mini-css-extract-plugin
export default {"range-picker":"date-ranges-compare_range-picker__pAmzy","range-picker__compare":"date-ranges-compare_range-picker__compare__0vZVE"};